export const configLazyLoad = {
  offset: 500,
  unmountIfInvisible: true,
  once: true,
};
